// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Typography from '@mui/material/Typography'
import React from 'react'
import { Trans } from 'react-i18next'
import AddThumbsUpButton from './AddThumbsUpButton'
import type { Incentives, StaffingPlanVariables } from './types'

type Props = {
  thumbsUpItems: Array<Incentives>
  currentEmployeeId: string
  registerThumbUp: (...args: Array<any>) => any
  variables: StaffingPlanVariables
}

class ThumbsUpServices extends React.Component<Props> {
  render() {
    const { thumbsUpItems, variables, registerThumbUp, date, stationId } = this.props
    return (
      <React.Fragment>
        {thumbsUpItems && thumbsUpItems.length ? (
          thumbsUpItems.map(({ id, name }) => (
            <AddThumbsUpButton
              key={id}
              thumbsUpItemId={id}
              label={name}
              variables={variables}
              registerThumbUp={registerThumbUp}
              date={date}
              stationId={stationId}
            />
          ))
        ) : (
          <Typography variant='h6'>
            <Trans i18nKey='employeeCard.addThumbsUpItems' components={{ lnk: <a href='/vuorokausijohtaminen' /> }} />
          </Typography>
        )}
      </React.Fragment>
    )
  }
}

export default ThumbsUpServices
